import { render, staticRenderFns } from "./AssetColumnParameter.vue?vue&type=template&id=18e43b50&"
import script from "./AssetColumnParameter.vue?vue&type=script&lang=ts&"
export * from "./AssetColumnParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports